
import { Component, Vue } from 'vue-property-decorator'
import { namespace, Action } from 'vuex-class'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import { getAnchorFromElement } from 'library/v4/components/OzPopoverModal.vue'

const wallCollectionsStore = namespace('wallCollections')
const browserStore = namespace('browser')

@Component({
  components: {
    OzTextButton,
    OzIcon,
  },
})
export default class SurfaceNavBookmarkButton extends Vue {
  OzTextButtonColorScheme = OzTextButtonColorScheme
  @Action bookmarkWallAndNotify
  @Action openEditBookmarksDialog

  @browserStore.Getter windowWidth!: number
  @wallCollectionsStore.Getter isActiveWallBookmarked

  get iconSize(): number {
    const oldSmartphoneBreakpoint = 480
    return this.windowWidth <= oldSmartphoneBreakpoint ? 24 : 16
  }

  editBookmarks(): void {
    const vue = this.$refs.bookmarkButton as Vue
    const el = vue?.$el
    const popoverAnchor = el
      ? {
          position: 'top',
          ...getAnchorFromElement(el),
        }
      : null
    this.openEditBookmarksDialog(popoverAnchor)
  }
}
